import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { filter: "url(#filter0_d_1295_22579)" }, [
      _createElementVNode("rect", {
        width: "16",
        height: "16",
        x: "2",
        y: "2",
        fill: "#fff",
        rx: "8"
      }),
      _createElementVNode("rect", {
        width: "15",
        height: "15",
        x: "2.5",
        y: "2.5",
        stroke: "#215f69",
        rx: "7.5"
      })
    ], -1)
  ]))]))
}
export default { render: render }